import React from 'react';
import musicJSON from '../../data/music.json';
import MusicCard from '../../components/MusicCard';
import RandomMusic from '../../components/RandomMusic';

const MusicIndex = () => {
    const musicCards = musicJSON.map((album, index) => (
        <MusicCard key={index} album={album} />
    ));

    return (
        <div className="container mx-auto px-4 py-4">
            <h1 className="text-6xl my-4">Music</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <h3 className='text-2xl'>I've been releasing music under the name 'regret will come' since 2015. 
                I soon realised that if I learned how to use electricity to manipulate raw 
                earth metals, allowing me to make flashy websites that sell you products, I could make 
                enough money to buy more synthesizers I don't know how to use. <br /><br />
                Here is some of the music I've released. It's pretty bad (hence the IT portfolio) but hopefully there's something in there you find fun :)</h3>
                <RandomMusic />
                </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                {musicCards}
            </div>
        </div>
    );
};

export default MusicIndex;